import { useEffect, useState } from "react";
import visibleImg from "../../../../../picture/Visible.png";
import { useGlobalContext } from "../../../../../Context/Context";
import Button from "../../../../Custom/Button/Button";
import axios from "axios";

const styles = {
  cell: { padding: "5px", textAlign: "center", fontSize: "14px" },
  button: { padding: "5px 30px", fontWeight: "bold" },
  flex: { display: "flex", alignItems: "center", justifyContent: "center" }
};

const mesecNaziv = ["", "Januar", "Februar", "Mart", "April", "Maj", "Jun",
  "Jul", "Avgust", "Septembar", "Oktobar", "Novembar", "Decembar"];

function GradilistePrethodniMeseci({ gradilisteId, setMesec, setGodina, setGradilisteId, setCurrentTabGradiliste }) {
  const [data, setData] = useState([]);
  const { dictionary, baseUrl, selectedMainEntity } = useGlobalContext();

  useEffect(() => {
    if (!gradilisteId) return;
    const fetch = async () => {
      try {
        const { data: res } = await axios.post(`${baseUrl}/evidencija7/get_meseci.php`, {
          gradiliste_id: gradilisteId,
        });
        if (res.status === 200) setData(res.data);
      } catch (e) { console.error(e); }
    };
    fetch();
  }, [gradilisteId]);

  const handlePreview = (item) => {
    setGodina(item.godina);
    setMesec(item.mesec);
  };

  const handleOdustani = () => {
    setGradilisteId("");
    setCurrentTabGradiliste("TEKUCI_MESEC");
  };

  return (
    <>
      <div style={{ overflowY: "auto", height: "calc(100% - 120px)" }}>
        <table style={{ width: "100%" }}>
          <thead>
            <tr>
              <th style={{ ...styles.cell, width: "10%" }}>{dictionary["redniBr"]}</th>
              <th style={styles.cell}>{dictionary["godina"]}</th>
              <th style={styles.cell}>{dictionary["mesec"]}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, i) => (
              <tr key={i}>
                <td style={styles.cell}>{i + 1}.</td>
                <td style={styles.cell}>{item.godina}</td>
                <td style={styles.cell}>{mesecNaziv[item.mesec] || item.mesec}</td>
                <td onClick={() => handlePreview(item)} style={{ width: "40px", cursor: "pointer" }}>
                  <div style={styles.flex}><img src={visibleImg} style={{ width: "30px" }} /></div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "15px" }}>
        <div onClick={handleOdustani}>
          <Button activation={true} style={styles.button}>{dictionary["odustani"]}</Button>
        </div>
      </div>
    </>
  );
}

export default GradilistePrethodniMeseci;